import { isOneToOneChat } from "@/firebase/utils";
import { OneToOneRawChat, RawChat } from "@/store/chats/types";

export const getIsOneToOneRawChat = (
  rawChat: RawChat,
): rawChat is OneToOneRawChat => {
  return isOneToOneChat(rawChat.id);
};
